import s from './Bubble.css'

interface iParams {
  center: boolean
  speed: number
  delay: number
}

const DEFAULT_PARAMS = {
  speed: 400,
  delay: 100,
  center: false
}

const getOffset = (
  wrap: HTMLElement,
  child: HTMLElement,
) => {
  if (wrap === child) {
    return {
      x: 0,
      y: 0
    }
  }

  return {
    x: child.offsetLeft,
    y: child.offsetTop
  }
}

const getCircleStyles = (
  wrap: HTMLElement,
  event: MouseEvent,
  { center, speed }: Partial<iParams>
) => {
  const size = wrap.clientWidth > wrap.clientHeight
    ? wrap.clientWidth
    : wrap.clientHeight

  const offset = getOffset(wrap, event.target as HTMLElement)

  const left = center
    ? 0
    : event.offsetX + offset.x - size

  const top = center
    ? 0
    : event.offsetY + offset.y - size

  const length = center
    ? size
    : size * 2

  return {
    left: `${left}px`,
    top: `${top}px`,
    width: `${length}px`,
    height: `${length}px`,
    animationDuration: `${speed}ms`
  }
}

export const showCircle = (
  wrap: HTMLElement,
  event: MouseEvent,
  config: Partial<iParams> = DEFAULT_PARAMS
) => {
  const params = {
    ...DEFAULT_PARAMS,
    ...config
  }

  const bubble = document.createElement('span')
  bubble.classList.add(s.Bubble__circle)

  const styles = getCircleStyles(wrap, event, params)

  Object.assign(bubble.style, styles)
  wrap.appendChild(bubble)

  setTimeout(() => bubble.remove(), params.speed + params.delay)
}
